import { render, staticRenderFns } from "./VideoWrapper.vue?vue&type=template&id=43cdb36a&"
import script from "./VideoWrapper.vue?vue&type=script&lang=js&"
export * from "./VideoWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports